module.exports = __webpack_public_path__ + "static/img/PBAE Cambio Climático.fde4e88e.png";